import styled from "@emotion/styled"
import { ButtonBase } from "@mui/material"
import { colors, size } from "@styles/theme"
import { PiChatCircleText, PiSliders } from "react-icons/pi"
import { TbAdjustments, TbAdjustmentsAlt, TbAdjustmentsCog, TbAdjustmentsHorizontal, TbEdit } from "react-icons/tb"

// Old Mandrake logo + button
{/* <FloatingButton
  onClick={() => newPost.open()}
  style={{
    backgroundColor: 'black',
    minWidth: size(7),
    height: size(7),
    border: 'none',
    padding: 0,
  }}>
  <img
    src={'https://mandrake-app.b-cdn.net/dev/application/icons/plus-icon.svg'}
    alt='create post'
    style={{
      flexShrink: 0,
      height: size(7),
      width: size(7)
    }}
  />
</FloatingButton> */}

const FloatActionBtn = styled(ButtonBase)`
  display: flex;
  align-items: center;
  justify-content: center;

  height: ${size(7)};
  width: ${size(7)};
  z-index: 2;
  
  border-radius: 100%;
  box-shadow: 0px 2px 5px rgba(0,0,0, 0.35);
  background-color: ${colors.statusColors['right_now']('primary')};
`

// Chat button for nearby profile
const chatBtnStyles = {
  position: 'fixed',
  bottom: size(4),
  right: size(1),
}

const ChatActionBtn = ({ openMessagesModal, buttonProps, iconProps, children }) => {
  return (
    <FloatActionBtn
      onClick={() => openMessagesModal()}
      style={chatBtnStyles}
      {...buttonProps}>
      {children}
      <PiChatCircleText
        size={size(4)}
        style={{ marginTop: -2 }}
        {...iconProps}
      />
    </FloatActionBtn>
  )
}

const PostActionBtn = ({ iconProps, ...rest }) => {
  return (
    <FloatActionBtn
      style={chatBtnStyles}
      {...rest}>
      <TbEdit
        size={size(3.75)}
        style={{ marginTop: -2 }}
        {...iconProps}
      />
    </FloatActionBtn>
  )
}

const FilterActionBtn = ({ showHiddenDisplay, openFilterDialog }) => {
  return (
    <FloatActionBtn
      disabled={showHiddenDisplay}
      onClick={() => openFilterDialog()}>
      {/* <TbAdjustmentsCog size={size(4)} style={{ transform: 'rotate(-90deg) scaleX(-1)' }} strokeWidth={1.4} /> */}
      {/* <TbAdjustmentsCog size={size(4)} strokeWidth={1.4} /> */}
      {/* <TbAdjustmentsAlt size={size(4)} strokeWidth={1.4} style={{ transform: 'rotate(-90deg)' }} /> */}
      {/* <TbAdjustmentsAlt size={size(4)} strokeWidth={1.4} /> */}
      {/* <TbAdjustments size={size(4)} strokeWidth={1.4} /> */}
      <TbAdjustmentsHorizontal size={size(4)} strokeWidth={1.4} />
      {/* <PiSliders size={size(3.5)} style={{ transform: 'rotate(90deg)' }} /> */}
    </FloatActionBtn>
  )
}

export { ChatActionBtn, chatBtnStyles, FilterActionBtn, PostActionBtn }

export default FloatActionBtn
